"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubOriginePatrimoineCorporationTrads = void 0;
exports.ESubOriginePatrimoineCorporationTrads = {
    creation_valorisation_entreprise: "Création/valorisation d'une entreprise ou d'un fonds de commerce",
    heritage: "Héritage",
    salaire: "Salaire",
};
